"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// Serbian
function numpf(n, f, s, t) {
  var n10 = n % 10;

  if (n10 === 1 && (n === 1 || n > 20)) {
    return f;
  } else if (n10 > 1 && n10 < 5 && (n > 20 || n < 10)) {
    return s;
  } else {
    return t;
  }
}

var strings = {
  prefixAgo: 'пре',
  prefixFromNow: 'за',
  suffixAgo: null,
  suffixFromNow: null,
  second: 'секунд',
  seconds: function seconds(value) {
    return numpf(value, '%d секунд', '%d секунде', '%d секунди');
  },
  minute: 'један минут',
  minutes: function minutes(value) {
    return numpf(value, '%d минут', '%d минута', '%d минута');
  },
  hour: 'један сат',
  hours: function hours(value) {
    return numpf(value, '%d сат', '%d сата', '%d сати');
  },
  day: 'један дан',
  days: function days(value) {
    return numpf(value, '%d дан', '%d дана', '%d дана');
  },
  month: 'месец дана',
  months: function months(value) {
    return numpf(value, '%d месец', '%d месеца', '%d месеци');
  },
  year: 'годину дана',
  years: function years(value) {
    return numpf(value, '%d годину', '%d године', '%d година');
  },
  wordSeparator: ' '
};
var _default = strings;
exports["default"] = _default;